export class LocalisationPageStackedParams {
    constructor(public showRestricted: boolean, public selectedOutlets: Array<number>,
                public selectedCustomObjects: Array<number>, public universal: boolean = false) {
    }
}
